

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FamilyManagement, FamilyGroupManagement } from '@/modules/neovehicle/models/family';

@Component
export default class extends Vue {
    @Prop()
    public isOpen: boolean;

    @Prop()
    public families: FamilyManagement[];

    @Prop()
    public familyGroups: FamilyGroupManagement[];

    public isOpenInternal = false;
    public id = 0;

    public headers = [
        { text: 'Código', value: 'id', sortable: false },
        { text: 'Família', value: 'familiaName', sortable: false },
        { text: 'Família Grupo', value: 'familyGroupName', sortable: false },
    ];

    public created() {
        this.isOpenInternal = this.isOpen;
    }

    public handleCancel() {
        this.$emit('cancel');
    }

    public handleMove() {
        this.$emit('move-selected', this.id);
    }
}
